export default __webpack_public_path__ + "2a9f33518d2534c9b9632d97dd7dafab.jpg";